<script lang="ts">
  import { fade } from "svelte/transition"
  import { t, getTextDirection } from "$lib/utils/i18n"

  let { competition } = $props()

  let descriptionElement = $state()
  let isDescriptionExpanded = $state(false)

  // Get text direction for RTL support
  const textDirection = $derived(getTextDirection(competition?.language))
  const isRTL = $derived(textDirection === "rtl")

  let descriptionClass = $derived(
    isDescriptionExpanded
      ? `text-gray-600 ${isRTL ? "px-2" : "px-2"}`
      : `text-gray-600 ${isRTL ? "px-2" : "px-2"} line-clamp-3 relative mb-4`,
  )

  function toggleDescription() {
    isDescriptionExpanded = !isDescriptionExpanded
  }
</script>

<h1
  class="text-2xl font-bold mb-2 text-left pl-2"
  class:pt-4={!competition?.images?.length}
  class:text-right={isRTL}
  class:text-left={!isRTL}
  class:pr-2={isRTL}
  class:pl-2={!isRTL}
  style="color: {competition?.widgetCustomizations?.colorSettings
    ?.primaryTextColor}; direction: {textDirection};"
>
  {competition.title}
</h1>
<div
  class={descriptionClass}
  bind:this={descriptionElement}
  style="word-break: break-word; overflow-wrap: break-word; max-width: 100%;color: {competition
    ?.widgetCustomizations?.colorSettings
    ?.secondaryTextColor}; direction: {textDirection};"
>
  <p
    style="word-break: break-word; overflow-wrap: break-word; max-width: 100%;"
  >
    {@html competition?.description}
  </p>
  <!-- {#if competition?.description?.length > 200 && !isDescriptionExpanded}
    <div
      class="fade-out"
      style="
        background: transparent;
        backdrop-filter: blur(10px);
        -webkit-mask-image: linear-gradient(to bottom, transparent, black);
        mask-image: linear-gradient(to bottom, transparent, black);
      "
    ></div>
  {/if} -->
</div>
{#if descriptionElement && competition?.description?.length > 200}
  <button
    class="text-sm text-gray-600 underline w-full text-left pl-2 mb-6 mt-4"
    class:text-right={isRTL}
    class:text-left={!isRTL}
    class:pr-2={isRTL}
    class:pl-2={!isRTL}
    style="color: {competition?.widgetCustomizations?.colorSettings
      ?.secondaryTextColor}; direction: {textDirection};"
    onclick={toggleDescription}
    transition:fade
  >
    {isDescriptionExpanded ? t("widget_show_less") : t("widget_show_more")}
  </button>
{/if}

<style>
  .fade-out {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 2rem;
  }
</style>
